<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('prazo-pagamento') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="$router.push({ name: 'ven-prazo-pagamento-list' })"
                                        >{{ $t('prazo-pagamento') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id ? $route.params.id : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToList()"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-children" v-if="isUpdate">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="permissao.read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="permissao.read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <DadosCadastrais
                    ref="tabDadosCadastrais"
                    v-if="abasAbertas['dados-cadastrais'] && !newToEdit && permissao.read"
                    v-show="abas[abaSelecionada] == 'dados-cadastrais'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                    @redirectToList="redirectToList"
                />

                <Parcelas
                    ref="tabParcelas"
                    v-if="abasAbertas['parcelas'] && permissao.read && isUpdate"
                    v-show="abas[abaSelecionada] == 'parcelas'"
                    :isUpdate="isUpdate"
                />
            </div>
        </div>
    </div>
</template>

<script>
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

// Abas
import DadosCadastrais from '@/components/vendas/prazo-pagamento/abas/DadosCadastrais';
import Parcelas from '@/components/vendas/prazo-pagamento/abas/Parcelas';

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == 'ven-prazo-pagamento-new' && to.name == 'ven-prazo-pagamento-edit') {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        DadosCadastrais,
        Parcelas,
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            abas: ['dados-cadastrais', 'parcelas'],
            abasAbertas: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            permissao: false,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-prazo-pagamento');

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: "prazo-pagamento'" },
            });
        } else {
            this.abasAbertas['dados-cadastrais'] = true;
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        redirectToList() {
            if (this.$route.query.tela) {
                let tempTela = null;
                let tempAba = null;
                let tempId = null;
                if (this.$route.query.tela == 'ven-prazo-pagamento-edit') {
                    tempAba = 'dados-cadastrais';
                    tempTela = this.$route.query.tela;
                    tempId = this.$route.query['id'];
                }
                if (tempTela != null) {
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: tempId },
                            query: { abaSelecionada: tempAba },
                        });
                    }, 1000);
                } else {
                    this.$router.push({ name: 'ven-prazo-pagamento-list' });
                }
            } else {
                this.$router.push({ name: 'ven-prazo-pagamento-list' });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: '';
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
